module.exports = __webpack_public_path__ + "static/media/img5.8f94c07c.jpg";